import React from 'react';

import './style.css';

export default function PoweredByBlazeIT({ color = 'white', isMain = false }) {
  const url = 'https://blazeit.sk/';

  return (
    <div className='powered'>
      <label
        style={{
          color: color === 'white' ? ' white' : 'black',
        }}
      >
        powered by
      </label>

      <a href={url}>
        <img
          src={
            color === 'white'
              ? require('./blazeit-white.gif').default
              : require('./blazeit-black.gif').default
          }
        />
      </a>
    </div>
  );
}
